<template>
   <div class="full-image-preview" :style="{zIndex}" :class="{hide}" @click="close">
        <span class="img-container" 
        :style="imgStyle" 
        @click.stop=""
        @dblclick="reset"
        @mousedown="onDragStart" @mousewheel.stop="onMouseWheel" 
        >
            <img :src="url" ref="image" @load="onImgLoad">
        </span>
        <span class="close" @click="close">
            <svg-icon href="#codelab-normal-screen" :width="27" :height="27"></svg-icon>
        </span>
    </div>
</template>
<script>
export default {
    name: "full-image-preview",
    props: {
        visible: Boolean,
        url: String
    },
    data(){
        return {
            hide: false,
            imgWidth: 0,
            imgHeight: 0,
            scale: 1,
            maxScale: 3,
            minScale: 0.2,
            dragStartX: 0,
            dragStartY: 0,
            translateX: 0,
            translateY: 0
        }
    },
    computed: {
        imgStyle(){
            return {
                width: this.imgWidth + 'px',
                height: this.imgHeight + 'px', 
                marginLeft: -0.5 * this.imgWidth + 'px', 
                marginTop: -0.5 * this.imgHeight + 'px', 
                transform: 'translate('+this.translateX+'px,'+this.translateY+'px) scale('+this.scale+')'
            };
        },
        zIndex(){
            if(this.$ELEMENT){
                return this.$ELEMENT.zIndex - 1;
            } else {
                return 1999;
            }
        }, 
    },
    mounted() {
        this.$nextTick(() => {
            let el = this.$el;
            document.body.appendChild(el);
            document.addEventListener("resize", this.onResize);
      });
    },
    methods: {
        close(){
            this.hide = true;
            setTimeout(() => {
                this.$emit("update:visible", false);
            },200);
        },
        onImgLoad(){
            let img = this.$refs.image;
            let {naturalWidth: width, naturalHeight: height} = img;
            let {clientWidth: containerWidth, clientHeight: containerHeight} = this.$el;
            let scale = 1;
            if(width <= containerWidth && height <= containerHeight){
                
                scale = 1;
            } else if(width > containerWidth && height <= containerHeight){
                
                scale = containerWidth / width;
            } else if(width <= containerWidth && height > containerHeight){
                
                scale = containerHeight / height;
            } else {
                
                scale = Math.min(containerHeight / height, containerWidth / width);
            }
            this.imgWidth = width * scale;
            this.imgHeight = height * scale;
            console.log(width, height, containerWidth, containerHeight);
        },
        onDragStart(e){
            let {clientX, clientY} = e;
            this.dragStartX = clientX;
            this.dragStartY = clientY;
            e.target.addEventListener("mousemove", this.onDragging);
            e.target.addEventListener("mouseup", this.onDragEnd);
            e.target.addEventListener("mouseleave", this.onDragEnd);
        },
        onDragging(e){
            let {clientX, clientY} = e;
            this.translateX += (clientX - this.dragStartX);
            this.translateY += (clientY - this.dragStartY); 
            this.dragStartX = clientX;
            this.dragStartY = clientY;
            
        },
        onDragEnd(e){
            this.onDragging(e);
            e.target.removeEventListener("mousemove", this.onDragging);
            e.target.removeEventListener("mouseup", this.onDragEnd);
            e.target.removeEventListener("mouseleave", this.onDragEnd);
        },
        onMouseWheel(e){
            if(e.wheelDelta > 0){
                this.scale = Math.min(this.maxScale, this.scale + 0.1);
            } else if(e.wheelDelta < 0) {
                this.scale = Math.max(this.minScale, this.scale - 0.1);
            }
        },
        bounding(el){
            let {offsetLeft, offsetTop} = el;
            console.log(offsetLeft, offsetTop, this.translateX, this.translateY);
            
        },
        reset(){
            this.scale = 1;
            this.translateX = 0;
            this.translateY = 0;
        },
        onResize(){
            this.$nextTick(() => {
                this.onImgLoad();
            })
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.onResize);
    },
}
</script>
<style lang="scss">
    .full-image-preview{
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: rgba(0,0,0,0.6);
        font-size: 0;
        position: fixed;
        left: 0;
        top: 0;
        animation: fadeIn ease-in 0.3s;
        animation-fill-mode: forwards;
        &.hide{
            animation: fadeOut ease-out 0.2s;
        }
        .img-container{
            display: inline-block;
            position: absolute;
            left: 50%;
            top: 50%;
            overflow: hidden;
            transform-origin: center center;
            img{
                width: 100%;
                pointer-events: none;
            }
        }
        .close{
            position: absolute;
            display: block;
            width: 45px;
            height: 45px;
            border-radius: 22.5px;
            right: 12px;
            bottom: 12px;
            background: #ffffff;
            line-height: 45px;
            text-align: center;
            svg{
                fill: #333333;
            }
            &:hover,&:active{
                background: $--codelab-primary-blue-3;
            }
        }
    }
    @keyframes fadeIn {
        from {opacity: 0}
        to {opacity: 1}
    }
    @keyframes fadeOut {
        from {opacity: 1}
        to {opacity: 0}
    }
</style>